import React, { useState } from "react";
import CommonCard from "../../../global/card";
import CommonSkeletonLoader from "../../../global/loading";
import SOURCES from "../../../../utils/constants";
import { useGenericQuery } from "../../../../queries/use-generic-query";
import { QUERY_KEYS } from "../../../../lib/query-constants";
import EnhancedInvoicesList from "./enhanced-invoices-list";

const EnhancedInvoices = () => {
    const [invoicesViewType, setInvoicesViewType] = useState(() => {
        return localStorage.getItem("invoicesViewType") || "GRID";
    });
    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });

    // Invoices data query
    const { data: invoices, isLoading, isFetching } = useGenericQuery({
        endpoint: "invoice/list",
        queryKey: QUERY_KEYS.invoices?.lists({ sortBy: sort.sortType, sortOrder: sort.sortOrder }) || ["invoices", sort],
        queryParams: {
            sortBy: sort.sortType,
            sortOrder: sort.sortOrder
        },
        onError: () => { },
        onSuccess: () => { },
    });

    const onSort = (column) => {
        setSort(prev => ({
            sortType: column,
            sortOrder: prev.sortType === column ? (prev.sortOrder === 1 ? -1 : 1) : 1
        }));
    };

    return (
        <CommonCard
            isListGridView={{
                show: true,
                viewType: invoicesViewType,
                setViewType: setInvoicesViewType,
                viewFor: "invoicesViewType"
            }}
            isLoading={{
                show: isLoading,
                loaderCmp: (
                    <CommonSkeletonLoader
                        type={invoicesViewType === "GRID" ? "card" : "table"}
                        tableLength={5}
                    />
                ),
            }}
            className={(!isLoading && isFetching) ? "opacity-50" : ""}
        >
            <EnhancedInvoicesList
                isLoading={isLoading}
                invoices={invoices || []}
                viewType={invoicesViewType}
                sortBy={sort.sortType}
                sortOrder={sort.sortOrder}
                onSort={onSort}
            />
        </CommonCard>
    );
};

export default EnhancedInvoices;
